import type {
  CustomFieldsArray,
  CustomFieldObjectNormalized,
  PhoneNumbersArray,
  PhoneNumberObject,
} from 'hooks/use-get-scan-user-profile/types';
import { normalizeValue } from 'common/utils/normalize-value';
import { formatSnakeToCamel } from 'common/utils/snake-to-camel';

export const normalizeCustomFields = (
  customFields: CustomFieldsArray['customFields'],
) =>
  customFields?.reduce(
    (previous, current) => ({
      ...previous,
      [formatSnakeToCamel(current.name)]: normalizeValue(current.value),
    }),
    {} as CustomFieldObjectNormalized,
  );

export const normalizePhoneNumbers = (
  phoneNumbers: PhoneNumbersArray['phoneNumbers'],
) =>
  phoneNumbers?.reduce((previous, current) => {
    if (current.description)
      return {
        ...previous,
        [current.description]: {
          number: current.number,
        },
      };
    return previous;
  }, {} as PhoneNumberObject);
